import { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { INameCardType } from "../../../interface/nameCard";
import classes from "../Footer.module.sass";
import { updateNameCards } from "../../../api";
import {
  IFlexMsgContent,
  useShareFlexMsg,
} from "../../../hooks/useShareFlexMsg";
import { CFlexBubble } from "../../../../flexMessageType";
import { FlexImage } from "@line/bot-sdk/dist/types";
import { useAppStateStore } from "../../../store/appState";
import { hasImageInThisNameCard } from "../../../utils/hasImageInThisNameCard";
import {
  fullImgModeNameCardButtonLabelConfig,
  fullImgModeNameCardButtonType,
} from "../../../config/fullImgModeNameCardConfig";

const UpdateNameCardFullImgModeFooter = () => {
  const { APP, NAMECARD_DATA, USER } = useAppStateStore();
  const { currentConfig } = APP;
  const { accessToken } = USER.userState;
  const { setNameCardV3CurrentPage, nameCardData } = NAMECARD_DATA;
  const {
    nameCardV3Data,
    nameCardV3Setting,
    currentCategory,
    nameCardV3Form,
    nameCardV3CurrentPage,
  } = nameCardData;
  const { altText, cardTitle } = nameCardV3Setting;
  const { user_category_id, user_folder_id, category_name, folder_name } =
    currentCategory;

  const navigate = useNavigate();
  const [updateCardID, setUpdateCardID] = useState<number>(0);

  const { sendFlexMsgFromCurrentContent } = useShareFlexMsg();

  const sendMsgContent: {
    _flexMsgContent: IFlexMsgContent;
    _message_text: string;
  } = {
    _flexMsgContent: {
      flexMsgType: { flexMsgType: "fullImgModeFlexMsg" },
      currentContent: nameCardV3Data,
    },
    _message_text: altText,
  };

  useEffect(() => {
    const tempHref = window.location.href;
    const tempHrefArr = tempHref.split("update/");
    const _card_id = Number(tempHrefArr[tempHrefArr.length - 1]);
    setUpdateCardID(_card_id);
  }, []);

  const getImgUrls = (content: CFlexBubble[]) => {
    const imageUrls: string[] = [];
    content.forEach((message) => {
      if (message.body?.contents && message.body.contents.length > 0) {
        if (
          message.body?.contents[0].type === "image" &&
          (message.body?.contents[0] as FlexImage).url.indexOf(
            currentConfig.REACT_APP_IMAGEBASEURL
          ) !== -1
        ) {
          if ((message.body?.contents[0] as FlexImage).url.indexOf("?time")) {
            imageUrls.push(
              (message.body?.contents[0] as FlexImage).url
                .split(currentConfig.REACT_APP_IMAGEBASEURL)[1]
                .split("?time")[0]
            );
          } else {
            imageUrls.push(
              (message.body?.contents[0] as FlexImage).url.split(
                currentConfig.REACT_APP_IMAGEBASEURL
              )[1]
            );
          }
        } else {
          if (
            message.body?.contents[0].type === "image" &&
            message.body?.contents[0].url.indexOf("?time") !== -1
          ) {
            return imageUrls.push(
              message.body?.contents[0].url.split("?time")[0]
            );
          } else {
            if (message.body?.contents[0].type === "image") {
              return imageUrls.push(
                (message.body?.contents[0] as FlexImage).url
              );
            }
          }
        }
      }
    });
    console.log("imageUrls", imageUrls);
    return imageUrls;
  };

  /**
   * 發更新資料庫該cardId名片資料 api
   */
  const UpdateNameCards = async () => {
    const removeS3BaseUrl = (content: CFlexBubble[]) => {
      const temp: CFlexBubble[] = JSON.parse(JSON.stringify(content));
      console.log("temp", temp);
      const result = temp.map((msg) => {
        if (msg.body?.contents && msg.body?.contents.length > 0) {
          if (
            msg.body?.contents[0].type === "image" &&
            msg.body?.contents[0].url.indexOf(
              currentConfig.REACT_APP_IMAGEBASEURL
            ) !== -1
          ) {
            (msg.body?.contents[0] as FlexImage).url = (
              msg.body?.contents[0] as FlexImage
            ).url.split(currentConfig.REACT_APP_IMAGEBASEURL)[1];
            return msg; // 返回修改後的 msg
          } else {
            return msg; // 返回原始的 msg
          }
        } else {
          return msg;
        }
      });
      return result;
    };

    const momileNumberAddTel = (content: CFlexBubble[]): CFlexBubble[] => {
      return content.map((cflexBubble) => {
        if (cflexBubble.body && cflexBubble.body.contents) {
          cflexBubble.body.contents = cflexBubble.body.contents.map(
            (flexComponent) => {
              if (
                flexComponent.type === "box" &&
                flexComponent.action &&
                flexComponent.action.type === "uri" &&
                flexComponent.action.label ===
                  fullImgModeNameCardButtonLabelConfig.phoneButton &&
                flexComponent.contents &&
                flexComponent.contents.length > 0 &&
                flexComponent.contents[0].type === "text" &&
                flexComponent.contents[0].text ===
                  fullImgModeNameCardButtonType.callphoneButton.text
              ) {
                // 只有在 uri 不是以 "tel:+886" 開頭時才添加前綴
                if (!flexComponent.action.uri.startsWith("tel:+886")) {
                  flexComponent.action.uri =
                    "tel:+886" + flexComponent.action.uri;
                }
              }
              return flexComponent;
            }
          );
        }
        return cflexBubble;
      });
    };

    const hasRemoveImageBaseurlCardContent: CFlexBubble[] = removeS3BaseUrl(
      JSON.parse(JSON.stringify(nameCardV3Data))
    );

    const resultNameCardContent: CFlexBubble[] = momileNumberAddTel(
      JSON.parse(JSON.stringify(hasRemoveImageBaseurlCardContent))
    );

    const nameCardContent: INameCardType = {
      card_type: nameCardV3Data.length === 1 ? 1 : 2,
      card_title: cardTitle,
      message_text: altText,
      card_content: JSON.stringify(resultNameCardContent),
      image_urls: getImgUrls(resultNameCardContent),
      user_category_id: user_category_id,
      category_name: category_name,
      user_folder_id: user_folder_id,
      folder_name: folder_name,
    };

    try {
      if (accessToken && updateCardID !== undefined) {
        const { data: res, error } = await updateNameCards(
          accessToken,
          updateCardID,
          nameCardContent
        );
        if (res) {
          const { data } = res;
          console.log("修改名片成功", data);
        }
        // 25.02.24 SCH ★★★
        if (error) {
          const errorData = JSON.stringify(error?.response?.data);
          if (
            errorData.includes(
              "You are not allowed to alter the category or folder"
            )
          ) {
            message.warn("您沒有權限修改名片的類別或資料夾", 7);
          } else if (
            errorData.includes(
              "The category or folder is not allowed to be changed"
            )
          ) {
            message.warn("「官網朋友圈」的名片類別或資料夾不能被修改", 7);
          } else if (errorData.includes("not permitted to alter data")) {
            message.warn("您沒有修改該張名片的權限", 7);
          } else if (errorData.includes("not permitted to edit")) {
            message.warn("您沒有修改名片的權限", 7);
          } else if (errorData.includes("You must be a paid member firstly")) {
            message.warn(
              "非付費會員不得編輯名片類別或資料夾，可在個人資料頁面下方點按〈付費解鎖進階功能〉，感謝您！",
              7
            );
          } else {
            message.error("修改名片失敗");
          }
        }
      }
    } catch (error) {
      console.log("修改名片失敗", error);
    }
  };

  const handleSubmit = async () => {
    if (!nameCardV3Form) return;
    try {
      const values = await nameCardV3Form.validateFields();
      if (!hasImageInThisNameCard(nameCardV3Data)) {
        message.error("尚未上傳底圖圖片，請至少上傳一張圖片在電子名片中。");
        return;
      }
      // 驗證通過才執行提交邏輯
      console.log("所有表單驗證通過，表單數據：", values);
      accessToken && UpdateNameCards();
      navigate(`/`);
      // 執行提交邏輯
    } catch (errorInfo) {
      // 驗證失敗，errorInfo 包含錯誤信息
      console.log("表單驗證失敗:", errorInfo);
      message.error("請依照欄位提示修正以符合所需格式");
      if (!hasImageInThisNameCard(nameCardV3Data)) {
        message.error("尚未上傳底圖圖片，請至少上傳一張圖片在電子名片中。");
        return;
      }
    }
  };

  const handleSend = async () => {
    try {
      if (!nameCardV3Form) return;
      const values = await nameCardV3Form.validateFields();
      if (!hasImageInThisNameCard(nameCardV3Data)) {
        message.error("尚未上傳底圖圖片，請至少上傳一張圖片在電子名片中。");
        return;
      }
      console.log("所有表單驗證通過，表單數據：", values);
      sendFlexMsgFromCurrentContent(
        sendMsgContent._flexMsgContent,
        sendMsgContent._message_text
      );
    } catch (error) {
      console.log("發送名片錯誤", error);
      message.error("發送名片錯誤,請依照欄位提示修正以符合所需格式");
      if (!hasImageInThisNameCard(nameCardV3Data)) {
        message.error("尚未上傳底圖圖片，請至少上傳一張圖片在電子名片中。");
        return;
      }
    }
  };

  const handlePrevPage = () => {
    if (nameCardV3CurrentPage > 0) {
      setNameCardV3CurrentPage(nameCardV3CurrentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (nameCardV3CurrentPage < nameCardV3Data.length - 1) {
      setNameCardV3CurrentPage(nameCardV3CurrentPage + 1);
    }
  };

  return (
    <div className={`${classes.buttonItem}  ${classes.nameCardEditorNavBar}`}>
      {/* 新增頁面切換按鈕 */}
      <div className={classes.pageNavigation}>
        <Button
          type="primary"
          className={`${classes.button} ${classes.pageButton}`}
          onClick={handlePrevPage}
          disabled={nameCardV3CurrentPage === 0}
        >
          <div className={classes.buttonWord}>上一頁</div>
        </Button>
        <span className={classes.pageInfo}>
          {nameCardV3CurrentPage + 1} / {nameCardV3Data.length}
        </span>
        <Button
          type="primary"
          className={`${classes.button} ${classes.pageButton}`}
          onClick={handleNextPage}
          disabled={nameCardV3CurrentPage === nameCardV3Data.length - 1}
        >
          <div className={classes.buttonWord}>下一頁</div>
        </Button>
      </div>

      <div className={classes.buttonContainer}>
        <div className={`${classes.buttonItem} ${classes.cancelButton}`}>
          <Button
            type="primary"
            className={`${classes.button} ${classes.buttonGreyBg}`}
            onClick={() => navigate(`/`)}
          >
            <div className={classes.buttonWord}>取消</div>
          </Button>
        </div>

        <div className={classes.buttonItem}>
          <Button
            type="primary"
            className={classes.button}
            onClick={handleSubmit}
          >
            <div className={classes.buttonWord}>儲存</div>
          </Button>
        </div>
        <div className={classes.buttonItem + " " + classes.sendButton}>
          <Button type="primary" className={classes.send} onClick={handleSend}>
            <div className={classes.buttonWord}>發送</div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNameCardFullImgModeFooter;
